module.exports = __webpack_public_path__ + "img/how_to_access_models.913bed26.png";